import type { CSSProperties } from 'react';

const CONTAINER_STYLE: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: '#ffffff',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '16px',
  fontFamily: 'Roboto, sans-serif',
  fontSize: '16px'
};

const BUTTON_STYLE: CSSProperties = {
  padding: '10px 20px',
  fontSize: '16px',
  fontFamily: 'Roboto, sans-serif',
  cursor: 'pointer',
  backgroundColor: '#1976d2',
  color: '#ffffff',
  border: 'none',
  borderRadius: '4px'
};

const handleRefresh = (): void => {
  globalThis.window.location.reload();
};

export const BootstrapErrorScreen = () => (
  <div style={CONTAINER_STYLE} role='alert'>
    <p>Connection failed. Please refresh the page.</p>
    <button
      type='button'
      style={BUTTON_STYLE}
      onClick={handleRefresh}
      onKeyDown={e => e.key === 'Enter' && handleRefresh()}
      aria-label='Refresh page'
    >
      Refresh
    </button>
  </div>
);
